import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetFlagsDadosTecnicos(idExternoOperacao?: string) {
  return useQuery(
    [
      URL.PLANO_OPERACIONAL.OBTER_FLAGS_DADOS_TECNICOS(idExternoOperacao),
      idExternoOperacao
    ],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_FLAGS_DADOS_TECNICOS(idExternoOperacao));
      return data;
    },
    {
      enabled: !!idExternoOperacao,
    }
  );
}

export default useGetFlagsDadosTecnicos;
